import Header from "@components/Header";
import PageBody from "@components/PageBody";
import Footer from "@components/Footer";
import styles from "./index.module.css";
import { Button, Container, Stack, Text, Group } from "@mantine/core";
import { Link } from "react-router-dom";
import { Paths } from "@app/paths";
import FormTextInput from "@/components/StyledTextInput/FormTextInput";
import FormCheckbox from "@/components/StyledCheckbox/FormCheckbox";
import useIntl from "@/infrastructure/hooks/useIntl";
import useSignUp from "./useSignUp";

function SignUp() {
  const t = useIntl();
  const { handleSubmit, control } = useSignUp();

  return (
    <>
      <Header />
      <PageBody column>
        <Container size="md" className={styles.container}>
          <form onSubmit={handleSubmit}>
            <Stack align="stretch" justify="center">
              <h1 className={styles.title}>{t("signUp.signUpTitle")}</h1>
              <Group grow>
                <FormTextInput
                  control={control}
                  name="firstName"
                  label={t("signUp.firstNameLabel")}
                  size="md"
                />
                <FormTextInput
                  control={control}
                  name="lastName"
                  label={t("signUp.lastNameLabel")}
                  size="md"
                />
              </Group>
              <FormTextInput
                control={control}
                name="email"
                label={t("signUp.emailLabel")}
                size="md"
              />
              <FormTextInput
                control={control}
                name="password"
                label={t("signUp.passwordLabel")}
                size="md"
              />
              <FormTextInput
                control={control}
                name="confirmPassword"
                label={t("signUp.confirmPasswordLabel")}
                size="md"
              />
              <FormCheckbox
                control={control}
                name="confirmOlderThan18"
                label={t("signUp.confirmOlderThan18Label")}
                size="md"
              />

              <Button size="md" type="submit" mt="md">
                {t("signUp.signUpButtonTitle")}
              </Button>
              {/* <Divider label="Or" labelPosition="center" />
              <Button size="md">Sign in with Google</Button> */}

              <Text ta="center" size="sm">
                {t("signUp.haveAnAccount")}
                <Text td="underline" fw={600}>
                  <Link to={Paths.SignIn} replace>
                    {t("signUp.signInHereLink")}
                  </Link>
                </Text>
              </Text>
            </Stack>
          </form>
        </Container>
      </PageBody>
      <Footer />
    </>
  );
}

export default SignUp;
